import { Grid, IconButton, makeStyles, Menu, MenuItem} from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import ArrowDropDownCircleOutlinedIcon from '@material-ui/icons/ArrowDropDownCircleOutlined';
import React, { useState } from 'react'
import { from_YYYYMMDDHHMMSS, prettyDate } from '../../../config/dateFormatting';
import { IMyBookingsListItem } from '../../../interface/interface';
import { foodCategoryColors } from '../../../constants/foodCategoryColors';

const useStyles = makeStyles((theme: any) => ({
    bookingListItemContainer: {
        borderLeft:'4px solid #43CA21',
        background: '#FFFFFF',
        boxShadow: '0px 4px 25px rgba(0, 0, 0, 0.1)',
        padding: 12,
        width: '100%',
        marginBottom: 8
    },
    bookingDate: {
        fontSize: 15,
        fontWeight: 700
    },
    bookingInfo: {
        fontSize: 13,
        fontWeight: 400,
        display: 'flex',
        justifyContent:'flex-start',
        alignItems:'center'
    },
    bookingRow: {
        display: 'flex',
        justifyContent:'space-between',
        alignItems:'center',
    },
    iconButtonStyle:{
        padding: 0
    },
    divider: {
        borderLeft: '1px solid green',
        minHeight: 15,
        height: '100%',
        marginLeft: 5,
        marginRight: 5,
        borderColor: theme.palette.primary.main
    },
    foodCategory: {
        fontSize: 7,
        color: 'white',
        display: 'flex',
        borderRadius: 50,
        padding: '2px 6px 2px',
        margin: 2,
        backgroundColor: 'black'
    },
    descriptionTitleContainer:{
        display:'flex',
        justifyContent:'start'
    },
    dishTitle:{
        fontSize: 12,
        fontWeight: 700
    },
    dishDescription:{
        fontSize: 12,
        fontWeight: 400
    },
    bookingInfoContainer:{
        paddingTop: 8
    },
    allergens:{
        fontSize: 10,
        fontWeight: 700,
        color: '#616161'
    },
    commentContainer:{
        display: 'flex',
        justifyContent: 'start',
        width: '100%',
        fontSize: 10,
        fontWeight: 700,
        color: theme.palette.primary.main
    }
}));

interface Props {
    bookingListItem: IMyBookingsListItem;
    handleDelete: (event: React.MouseEvent<HTMLLIElement, MouseEvent>,bookingId: string) => void;
    handleEdit: (event: React.MouseEvent<HTMLLIElement, MouseEvent>,bookingId: string) => void;
    disabled: boolean;
}

export const MyBookingsListItem: React.FC<Props> = ({bookingListItem,handleDelete,handleEdit,disabled}) => {
    const classes = useStyles();
    const [moreInfo, setMoreInfo] = useState(false);
    const bookingDate = from_YYYYMMDDHHMMSS(bookingListItem.seatingStart);

    const bookingItems: any = []
    let viewCategories = []
    for (const [index, myBookingsListOrderedDish] of bookingListItem.myBookingsListOrderedDishes.entries()){
        /* View Food categories*/
        viewCategories = []
        for (const [categoryIndex, category] of myBookingsListOrderedDish.foodCategories.entries()) {
            const background = {
                backgroundColor: '#999999'
            }

            for(const [categoryColorIndex, categoryColor] of foodCategoryColors.entries()){
                if (category=== categoryColor.category) {
                    background.backgroundColor = categoryColor.color;
                }
            }
            viewCategories.push(<div key={category} className={classes.foodCategory} style={background}>{category}</div>)
        }

        /* View allergens*/
        let concatAllergens = 'Allergens: ';
        myBookingsListOrderedDish.allergens.forEach((allergen, index) =>{
            concatAllergens += allergen;
            if(index !== myBookingsListOrderedDish.allergens.length-1){
                concatAllergens += ', '
            }
        })

        bookingItems.push(
            <div key={myBookingsListOrderedDish.dishId} className={classes.bookingInfoContainer}>
                <div className={classes.descriptionTitleContainer}>
                    <div className={classes.dishTitle}>
                        {myBookingsListOrderedDish.bookingItemQuantity} x  {myBookingsListOrderedDish.dishTitle}
                    </div>
                    {viewCategories}
                </div>
                <div className={classes.dishDescription}>
                    {myBookingsListOrderedDish.dishDescription}
                </div>
                <div className={classes.allergens} hidden={myBookingsListOrderedDish.allergens.length=== 0}>
                    {concatAllergens}
                </div>
            </div>
        )

        if(bookingListItem.bookingComment !== ''){
            bookingItems.push(
                <div className={classes.commentContainer}>
                    Comment: {bookingListItem.bookingComment}
                </div>
            )
        }

    }

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };


    return (
        <div className={classes.bookingListItemContainer} style={{borderColor: disabled ? "#666666" : "#6178ed"}}>
            <div className={classes.bookingRow}>
                <div className={classes.bookingDate}>
                    {prettyDate(bookingDate,false,true)}
                </div>
                <IconButton
                    aria-label="add to shopping cart" 
                    className={classes.iconButtonStyle}
                    disabled={disabled}
                    disableRipple={disabled}
                    id="bookingOption-button"
                    aria-controls="option-menu"
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}>
                    <MoreHorizIcon />
                </IconButton>
                <Menu
                    id="option-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                    'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem onClick={(e) => {handleEdit(e,bookingListItem.bookingId);handleClose()}} disabled={disabled}>Edit</MenuItem>
                    <MenuItem onClick={(e) => {handleDelete(e,bookingListItem.bookingId);handleClose()}} disabled={disabled}>Delete</MenuItem>
                </Menu> 
            </div>
            <div className={classes.bookingRow}>
                <div className={classes.bookingInfo}>
                    {bookingListItem.seatingName} <div className={classes.divider}>  </div> {prettyDate(bookingDate,true,false)} <div className={classes.divider}> </div> {bookingListItem.totalNoPeople} x people
                </div>
                <IconButton  aria-label="add to shopping cart" className={classes.iconButtonStyle} onClick={() => setMoreInfo(!moreInfo)}>
                    <ArrowDropDownCircleOutlinedIcon/>
                </IconButton>   
            </div>
            {moreInfo ?
            <div>
                <Grid
                container
                justifyContent="space-between"
                alignItems="center">
                    {bookingItems}
                </Grid>
            </div>
            :
            <div></div>
            }
        </div>
    );
}